// ================================
// frontend/src/pages/GoogleAuthCallback.js
// Page qui reçoit le callback après OAuth Google
// ================================

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const GoogleAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log('🔄 Traitement callback Google OAuth...');
    
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');
    const error = searchParams.get('error');
    
    if (error) {
      console.error('❌ Erreur OAuth:', error);
      
      // Envoyer message à la fenêtre parent (popup)
      if (window.opener) {
        window.opener.postMessage({
          type: 'GOOGLE_AUTH_ERROR',
          error: error
        }, window.location.origin);
        window.close();
      } else {
        // Si pas de popup, rediriger vers login avec erreur
        navigate('/login?error=' + error);
      }
      return;
    }
    
    if (token && userParam) {
      console.log('✅ Token et user reçus');
      
      try {
        const user = JSON.parse(decodeURIComponent(userParam));
        console.log('👤 Utilisateur:', user);
        
        // Si c'est une popup, envoyer le message au parent
        if (window.opener) {
          console.log('📤 Envoi message à la fenêtre parent');
          window.opener.postMessage({
            type: 'GOOGLE_AUTH_SUCCESS',
            token: token,
            user: user
          }, window.location.origin);
          
          // Fermer la popup après 500ms
          setTimeout(() => {
            window.close();
          }, 500);
        } else {
          // Si ce n'est pas une popup (navigation directe), sauvegarder et rediriger
          console.log('💾 Sauvegarde locale et redirection');
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          navigate('/dashboard');
        }
        
      } catch (error) {
        console.error('❌ Erreur parsing user:', error);
        navigate('/login?error=parse_error');
      }
    } else {
      console.warn('⚠️ Paramètres manquants');
      navigate('/login?error=missing_params');
    }
    
  }, [searchParams, navigate]);
  
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px',
          animation: 'spin 1s linear infinite'
        }}>
          ⏳
        </div>
        <h2 style={{
          margin: '0 0 10px 0',
          color: '#333',
          fontSize: '24px'
        }}>
          Connexion avec Google...
        </h2>
        <p style={{
          margin: 0,
          color: '#666',
          fontSize: '14px'
        }}>
          Veuillez patienter
        </p>
      </div>
      
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default GoogleAuthCallback;